function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  width: 56,
  height: 56,
  rx: 28,
  fill: "#F25B60",
  fillOpacity: 0.1
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 8,
  y: 8,
  width: 40,
  height: 40,
  rx: 20,
  fill: "#F92626"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M35.5119 21.85L29.5719 18.42C28.6019 17.86 27.4019 17.86 26.4219 18.42L20.4919 21.85C19.5219 22.41 18.9219 23.45 18.9219 24.58V31.42C18.9219 32.54 19.5219 33.58 20.4919 34.15L26.4319 37.58C27.4019 38.14 28.6019 38.14 29.5819 37.58L35.5219 34.15C36.4919 33.59 37.0919 32.55 37.0919 31.42V24.58C37.0819 23.45 36.4819 22.42 35.5119 21.85ZM27.2519 23.75C27.2519 23.34 27.5919 23 28.0019 23C28.4119 23 28.7519 23.34 28.7519 23.75V29C28.7519 29.41 28.4119 29.75 28.0019 29.75C27.5919 29.75 27.2519 29.41 27.2519 29V23.75ZM28.9219 32.63C28.8719 32.75 28.8019 32.86 28.7119 32.96C28.5219 33.15 28.2719 33.25 28.0019 33.25C27.8719 33.25 27.7419 33.22 27.6219 33.17C27.4919 33.12 27.3919 33.05 27.2919 32.96C27.2019 32.86 27.1319 32.75 27.0719 32.63C27.0219 32.51 27.0019 32.38 27.0019 32.25C27.0019 31.99 27.1019 31.73 27.2919 31.54C27.3919 31.45 27.4919 31.38 27.6219 31.33C27.9919 31.17 28.4319 31.26 28.7119 31.54C28.8019 31.64 28.8719 31.74 28.9219 31.87C28.9719 31.99 29.0019 32.12 29.0019 32.25C29.0019 32.38 28.9719 32.51 28.9219 32.63Z",
  fill: "white"
});

var SvgCautionIconDark = function SvgCautionIconDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCautionIconDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/caution-icon-dark.d0cd0441.svg";
export { ForwardRef as ReactComponent };